import { Box, Button, Stack, Typography } from '@mui/material';
import Iconify from 'src/components/iconify';
import { useCampaignLeaksT } from './i18n';

export function ErrorState({ onRetry }: { onRetry: () => void }) {
  const ct = useCampaignLeaksT();
  return (
    <Box sx={{ p: 3, textAlign: 'center' }} data-testid="error-state">
      <Typography variant="h6" color="error" gutterBottom>
        {ct('states.error_title')}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        {ct('states.error_message')}
      </Typography>
      <Button variant="outlined" onClick={onRetry}>
        {ct('states.retry')}
      </Button>
    </Box>
  );
}

export function EmptyState({ message, icon }: { message: string; icon?: string }) {
  return (
    <Stack alignItems="center" spacing={1.5} sx={{ py: 6, px: 3, textAlign: 'center' }} data-testid="empty-state">
      {icon && <Iconify icon={icon} width={40} sx={{ color: '#919EAB' }} />}
      <Typography variant="body2" color="text.secondary">
        {message}
      </Typography>
    </Stack>
  );
}
